import React from "react";
import { Col, Row, Button } from "reactstrap";
import CompetitiveInsightsChart from "../DashboardCharts/CompetitiveInsightsChart";
import DashboardDistributorBreakdownChart from "../DashboardCharts/DashboardDistributorBreakdownChart";
import DashboardTotalOpportunititesChart from "../DashboardCharts/DashboardTotalOpportunitiesChart";
import useDashboard from "../useDashboard";
import { Theme } from "../../../config/constants";

const DashboardChartsCard = () => {
    const { handleClickViewCampaignManagement } = useDashboard.useDashboard();

    return (
        <Row style={{background: 'lightgray'}}>
            <Col style={{gap: '1px', display: 'grid'}}>
                <Row style={{background: 'white'}}>
                    <DashboardDistributorBreakdownChart />
                </Row>
                <Row style={{background: 'white'}}>
                    <CompetitiveInsightsChart />
                </Row>
                <Row style={{background: 'white'}}>
                    <DashboardTotalOpportunititesChart />
                </Row>
                <Row style={{gap: '1px', background: 'white'}}>
                    <Col className="w-100 d-flex flex-column justify-content-center" style={{minHeight: '315px', background: 'white'}}>
                        <Row className="mx-auto w-fc">
                            <img src={'./vectorcharts.png'} alt='Fake Charts and Graphs' style={{height: '59px', width: '211px'}}/>
                        </Row>
                        <Row className="mx-auto w-fc">
                            <div className="main-header text-size-18">Want more Campaign Insights?</div>
                        </Row>
                        <Row className="mx-auto w-fc">
                            <div className="text-grayText text-center">Access our Campaign Management page for full insights on your campaigns.</div>
                        </Row>
                        <Row className="mx-auto my-1 w-fc">
                            <Button 
                                block 
                                className='py-2 button-label' 
                                size='sm' 
                                style={{width: '250px'}}
                                onClick={() => handleClickViewCampaignManagement()}
                                color={Theme().colors.accentName}>View Campaign Management
                            </Button>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>
    )   
}

export default DashboardChartsCard;